import { render, staticRenderFns } from "./AlibeyFlightFields.vue?vue&type=template&id=82548cb0&scoped=true"
import script from "./AlibeyFlightFields.vue?vue&type=script&lang=js"
export * from "./AlibeyFlightFields.vue?vue&type=script&lang=js"
import style0 from "./AlibeyFlightFields.vue?vue&type=style&index=0&id=82548cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82548cb0",
  null
  
)

export default component.exports